import React from 'react';
import './BackgroundSlideshow.css';

export default function BackgroundSlideshow({ className }) {
    return (
        <div className={`background-slideshow ${className || ''}`}>
            <picture className="bg-slide slide-1">
                <source srcSet={`${process.env.PUBLIC_URL}/questions-bg/bg-1.webp`} type="image/webp" />
                <img src={`${process.env.PUBLIC_URL}/questions-bg/bg-1.png`} alt="" />
            </picture>
            <picture className="bg-slide slide-2">
                <source srcSet={`${process.env.PUBLIC_URL}/questions-bg/bg-2.webp`} type="image/webp" />
                <img src={`${process.env.PUBLIC_URL}/questions-bg/bg-2.png`} alt="" />
            </picture>
            <picture className="bg-slide slide-3">
                <source srcSet={`${process.env.PUBLIC_URL}/questions-bg/bg-3.webp`} type="image/webp" />
                <img src={`${process.env.PUBLIC_URL}/questions-bg/bg-3.png`} alt="" />
            </picture>
            <picture className="bg-slide slide-4">
                <source srcSet={`${process.env.PUBLIC_URL}/questions-bg/bg-4.webp`} type="image/webp" />
                <img src={`${process.env.PUBLIC_URL}/questions-bg/bg-4.png`} alt="" />
            </picture>
        </div>
    );
}
